import { Tooltip } from '@cian/ui-kit';
import { Faq16 } from '@cian/ui-kit/prev';
import * as React from 'react';
import * as styles from './AutoprolongHint.css';

interface IProps {
  typeName: string;
}

export const AutoprolongHint = (props: IProps) => {
  const { typeName } = props;

  return (
    <Tooltip
      theme="black"
      placement="top-start"
      title={
        <div className={styles['content']}>
          Включите автопродление, чтобы объявления из&nbsp;{typeName} не&nbsp;были сняты с&nbsp;публикации, когда
          закончится срок действия {typeName}
        </div>
      }
    >
      <Faq16 color="primary_100" cursor="pointer" />
    </Tooltip>
  );
};
